module.exports = __webpack_public_path__ + "img/f-05.63521a49.jpg";